import Vue from 'vue'
import vClickOutside from 'v-click-outside'

Vue.use(vClickOutside)


// WEBPACK FOOTER //
// ./src/plugins/v-click-outside.js